<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary" to="/dashboard/license">add new item</router-link>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>تعداد روز</th>
                    <th>قیمت</th>
                    <th>سکه</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="license in licenses" :key="license._id">
                    <td>{{ license.title }}</td>
                    <td>{{ license.period }}</td>
                    <td>{{ license.price }}</td>
                    <td>{{ license.coin }}</td>
                    <td>{{ license.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/license', query: { id: license._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import licenseService from '../../../../services/license';
export default {
  name: 'league',
  data() {
    return {
      licenses: [],
    };
  },
  created() {
    this.getLicenses({});
  },
  methods: {
    async getLicenses(conditions) {
      try {
        const data = await licenseService.getLicenses(conditions);
        this.licenses = data.licenses;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
